module.exports = __webpack_public_path__ + "static/media/private-user-pin-danger.95235843.svg";